import React, { useEffect, useRef, useState } from 'react'
import { useTranslation } from 'react-multi-lang'

// Stylesheet
import './SalariesHistory.css'

// Components
import Modal from '../../../components/Modal/Modal'

interface SalariesHistoryProps {
    isOpen: boolean;
    toggle(): any;
    employee_name: string;
    salaries: {
        date: string;
        salary: number;
        additional_time: number;
        additional_value: number;
        absence_time: number;
        discount_value: number;
        net_salary: number;
    }[]
}

export default (props: SalariesHistoryProps) => {

    // Translation
    const t = useTranslation()

    return (
        <>
            <Modal open={props.isOpen} toggle={props.toggle}>
                <h2 className="text-center" style={{ margin: "0 0 20px" }}>{props.employee_name}</h2>
                <div className="dashboard-table" style={{ width: 1000 }}>
                    <table>
                        <thead>
                            <tr>
                                <th>{t("month")}</th>
                                <th>{t("salary")}</th>
                                <th>{t("additional_hours")}</th>
                                <th>{t("additional_value")}</th>
                                <th>{t("absence_hours")}</th>
                                <th>{t("discount_value")}</th>
                                <th>{t("net_salary")}</th>
                            </tr>
                        </thead>
                        <tbody>
                            {props.salaries.map(salary => (
                                <tr>
                                    <td>{((new Date(salary.date)).getUTCMonth() + 1) + "/" + (new Date(salary.date)).getFullYear()}</td>
                                    <td>{salary.salary}</td>
                                    <td style={{ color: '#2ecc71' }}>{salary.additional_time}</td>
                                    <td style={{ color: '#2ecc71' }}>{salary.additional_value}</td>
                                    <td style={{ color: 'tomato' }}>{salary.absence_time}</td>
                                    <td style={{ color: 'tomato' }}>{salary.discount_value}</td>
                                    <td style={{ fontSize: 15 }}>{salary.net_salary}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </Modal>
        </>
    )

}